var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAutomationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.58825 1.52652C9.64527 1.26047 9.5161 0.989351 9.27357 0.866001C9.03104 0.742651 8.73586 0.797952 8.55443 1.00073L1.75443 8.60073C1.59665 8.77708 1.55724 9.02969 1.65383 9.24571C1.75041 9.46173 1.96494 9.60081 2.20157 9.60081H7.45938L6.41489 14.4751C6.35788 14.7411 6.48704 15.0123 6.72958 15.1356C6.97211 15.259 7.26728 15.2037 7.44872 15.0009L14.2487 7.40088C14.4065 7.22454 14.4459 6.97193 14.3493 6.75591C14.2527 6.53989 14.0382 6.40081 13.8016 6.40081H8.54377L9.58825 1.52652Z",
    fill: "#CCCCCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutomationIcon);
export default __webpack_public_path__ + "static/media/automation_icon.b9885c11f2ddaf7c131f72af1f898b60.svg";
export { ForwardRef as ReactComponent };